export default "__VITE_ASSET__skhaxtuJ__"